import { Validators } from "@angular/forms";
import { IFieldConfig } from "src/app/domain/IFieldConfig";
import { FeeServiceEnum } from "src/app/domain/registration/enums/fee-service.enum";
import { TypeComponentFieldEnum } from "src/app/domain/registration/enums/type-component-dynamic.enum";

export const FEE_CONFIG_CRUD_CONFIG: IFieldConfig[] = [
    {
        name: 'numero_cnpj',
        label: 'CPF/CNPJ',
        type: TypeComponentFieldEnum.INPUT_CPF_AND_CNPJ,
        placeholder: '00.000.000/0000-00',
        validation: [Validators.required]
    },
    {
        name: 'pixCashin',
        label: 'PIX Cash-in',
        type: TypeComponentFieldEnum.INPUT_PERCENT,
        options: Object.values(FeeServiceEnum.PIX_CASHIN_PERCENTUAL)
    },
    {
        name: 'pixStaticCashin',
        label: 'PIX Static Cash-in',
        type: TypeComponentFieldEnum.INPUT_PERCENT,
        options: Object.values(FeeServiceEnum.PIX_STATIC_CASHIN)
    },
    {
        name: 'boletoCashin',
        label: 'Boleto Cash-in',
        type: TypeComponentFieldEnum.INPUT_PERCENT,
        options: Object.values(FeeServiceEnum.BOLETO_CASHIN)
    },
    {
        name: 'pixCashout',
        label: 'PIX Cash-out',
        type: TypeComponentFieldEnum.INPUT_PERCENT,
        options: Object.values(FeeServiceEnum.PIX_CASHOUT)
    },
    {
        name: 'pixCashinSemStatus',
        label: 'PIX Cash-in Sem Status',
        type: TypeComponentFieldEnum.INPUT_PERCENT,
        options: Object.values(FeeServiceEnum.PIX_CASHIN_SEM_STATUS)
    },
    
     {
        name: 'pixCashinValue',
        label: 'PIX Cash-in',
        type: TypeComponentFieldEnum.INPUT_CURRENCY,
        options: Object.values(FeeServiceEnum.PIX_CASHIN_PERCENTUAL)
    },
    {
        name: 'pixStaticCashinValue',
        label: 'PIX Static Cash-in',
        type: TypeComponentFieldEnum.INPUT_CURRENCY,
        options: Object.values(FeeServiceEnum.PIX_STATIC_CASHIN)
    },
    {
        name: 'boletoCashinValue',
        label: 'Boleto Cash-in',
        type: TypeComponentFieldEnum.INPUT_CURRENCY,
        options: Object.values(FeeServiceEnum.BOLETO_CASHIN)
    },
    {
        name: 'pixCashoutValue',
        label: 'PIX Cash-out',
        type: TypeComponentFieldEnum.INPUT_CURRENCY,
        options: Object.values(FeeServiceEnum.PIX_CASHOUT)
    },
    {
        name: 'pixCashinSemStatusValue',
        label: 'PIX Cash-in Sem Status',
        type: TypeComponentFieldEnum.INPUT_CURRENCY,
        options: Object.values(FeeServiceEnum.PIX_CASHIN_SEM_STATUS)
    }
];
